import React from "react";
import { TextInput, View } from "react-native";
import { Typography } from "../Typography.component";
import { useBiblo } from "../../hooks/Biblo.hook";
import { getTextStyles, getViewStyles } from "../../helpers/getStyles.helper";
import { ErrorBoundary } from "../ErrorBoundary.component";
export const ReaderControls = _ref => {
  let {
    props,
    updateProp,
    parent,
    shown,
    setShown
  } = _ref;
  const {
    readerOptions,
    defaultStyles,
    disableDefaultStyles: disableDefaultStylesGlobal
  } = useBiblo();
  const propsArray = Object.entries(props);
  const disableDefaultStyles = disableDefaultStylesGlobal || readerOptions.disableDefaultStyles;
  const Controls = readerOptions.controlsComponent || View;
  const inputStyle = getTextStyles(readerOptions.controlsInputStyle, defaultStyles.textInput, disableDefaultStyles);
  return shown || readerOptions.controlsComponent ? /*#__PURE__*/React.createElement(ErrorBoundary, {
    type: "propsComponent"
  }, /*#__PURE__*/React.createElement(Controls, {
    shown: shown,
    setShown: setShown,
    parent: parent,
    style: readerOptions.controlsStyle,
    textStyle: readerOptions.controlsTextStyle,
    inputStyle: readerOptions.controlsInputStyle
  }, propsArray.map((_ref2, index) => {
    let [prop, data] = _ref2;
    return !["hidden", "undefined", "function"].includes(data.type) && /*#__PURE__*/React.createElement(View, {
      key: `${prop}-${index}`,
      style: getViewStyles(readerOptions.controlsStyle, {
        marginHorizontal: parent === "item" ? defaultStyles.spacing : 0,
        marginTop: defaultStyles.spacing
      }, disableDefaultStyles)
    }, /*#__PURE__*/React.createElement(Typography, {
      bold: true,
      style: getTextStyles(readerOptions.controlsTextStyle, {
        marginBottom: 5
      }, disableDefaultStyles),
      disableDefaultStyles: disableDefaultStyles
    }, data.title), data.type === "string" ? /*#__PURE__*/React.createElement(TextInput, {
      defaultValue: data.value,
      placeholder: "undefined",
      onChangeText: newValue => updateProp(prop, newValue),
      style: inputStyle
    }) : data.type === "number" ? /*#__PURE__*/React.createElement(TextInput, {
      defaultValue: typeof data.value === "number" ? data.value.toString() : "",
      keyboardType: "numeric",
      placeholder: "undefined",
      onChangeText: newValue => updateProp(prop, parseFloat(newValue)),
      style: inputStyle
    }) : null);
  }))) : null;
};
//# sourceMappingURL=ReaderControls.component.js.map